import { gql } from '@apollo/client'

export const Query = gql`
  query AssetTypeMaintenanceSchedules(
    $companyId: ID!,
    $filters: AssetTypeMaintenanceScheduleFilters,
    $after: String,
    $before: String,
    $first: Int,
    $last: Int
  ) {
    assetTypeMaintenanceSchedules(
      companyId: $companyId,
      filters: $filters,
      after: $after,
      before: $before,
      first: $first,
      last: $last
    ) {
      nodes {
        id
        maintenanceSchedule {
          id
          details
          summary
          maintenanceType {
            id
            name
          }
        }
        assetType {
          id
          name
        }
      }
      pageInfo { startCursor endCursor hasNextPage hasPreviousPage }
    }
  }
`
